exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".with-tooltip__with-tooltip__1PYnY{display:-ms-flexbox;display:flex;position:relative;height:inherit;cursor:pointer}.with-tooltip__with-tooltip__1PYnY:focus{outline:none}.with-tooltip__with-tooltip__1PYnY:hover .with-tooltip__tooltip__1kRZn{display:inline}.with-tooltip__tooltip__1kRZn{box-sizing:border-box;display:none;position:absolute;z-index:126;top:-50px;padding-bottom:28px;left:50%;transform:translateX(-50%);text-align:center}.with-tooltip__tooltip-inner__15qpC{display:inline-block;padding:0 13px;background-color:#000;color:#fff;height:22px;line-height:22px;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"with-tooltip": "with-tooltip__with-tooltip__1PYnY",
	"withTooltip": "with-tooltip__with-tooltip__1PYnY",
	"tooltip": "with-tooltip__tooltip__1kRZn",
	"tooltip-inner": "with-tooltip__tooltip-inner__15qpC",
	"tooltipInner": "with-tooltip__tooltip-inner__15qpC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/with-tooltip/with-tooltip.styl
// module id = 2944
// module chunks = 1